<template>
  <div class="luck2021">
    <div class="luck2021__header">
      <topHeader :imgPath="imgPath + 'top/'" />
    </div>
    <div class="luck2021__counselors">
      <div class="luck2021__price">
        <topPrice />
      </div>
      <div class="luck2021__counselor">
        <counselorList :list="filterdCounselors" :imgPath="imgPath + 'top/'" />
      </div>
      <!-- 矢印のやつ -->
      <svg xmlns="http://www.w3.org/2000/svg" :viewBox="`0 0 ${elWidth} 60`" class="luck2021__svg">
        <path class="luck2021__path" :d="`M 0,0 L 0,60 L ${elWidth/2},60 L 0,0 Z`"></path>
        <path class="luck2021__path" :d="`M ${elWidth},0 L ${elWidth},60 L ${elWidth/2},60 L ${elWidth},0 Z`"></path>
      </svg>
    </div>
    <div class="luck2021__subsc" v-if="!subscriptionFlg">
      <prSubsc
        :imgPath="imgPath"
        :sbscUrl="sbscUrl"
      />
    </div>
  </div>
</template>

<script>
import topHeader from "./topHeader";
import topPrice from "./topPrice";
import counselorList from "./counselorList";
import prSubsc from "./prSubsc";

export default {
  name: "Yearluck2021Top",
  components: {
    topHeader,
    topPrice,
    counselorList,
    prSubsc,
  },
  data() {
    return {
      imgPath: '/static/img/yearluck/y2021/',
      elWidth: 375,
    }
  },
  computed: {
    // ゲッターズだけ除外
    filterdCounselors() {
      return this.counselors.filter((item) => {
        return item.menu_id != 6007
      })
    }
  },
  props: {
    counselors: {
      type: Array,
      default () {
        return []
      }
    },
    subscriptionFlg: {
      type: Boolean,
      default: false
    },
    sbscUrl: {
      type: String,
      default: '/user/login'
    }
  },
  mounted () {
    this.setElWidth()
    window.addEventListener('resize', this.setElWidth);
  },
  beforeDestroy() {
   window.removeEventListener('resize', this.setElWidth);
  },
  methods: {
    // svg 用に幅を設定
    setElWidth () {
      this.elWidth = this.$el.clientWidth
    }
  }
}
</script>

<style scoped lang="scss">
.luck2021 {
  padding: 0 0 60px;
  &__header {}
  &__price {
    margin-bottom: 24px;
  }
  &__counselor {}
  &__subsc {
    margin: 5.35% auto 0;
  }
  &__counselors {
    // margin: -10.1% auto 0;
    margin: 0 auto;
    // padding: calc(10.1% + 20px) 8.55% 80px;
    padding: 21px 8.55% 80px;
    // $bg1: #FFED8D;
    // $bg2: #FFE681;
    $bg1: #FFD3E1;
    $bg2: #FFC0E7;
    $bg3: transparent;
    background-color: $bg1;
    background-image:
      linear-gradient(45deg, $bg2 25%, $bg3 25%, $bg3 75%, $bg2 75%),
      linear-gradient(45deg, $bg2 25%, $bg3 25%, $bg3 75%, $bg2 75%);
    background-size: 20px 20px;
    background-position: 0 0, 10px 10px;
    position: relative;
  }
  &__svg {
    position: absolute;
    bottom: -1px;
    left: 0;
    width: 100%;
  }
  &__path {
    fill: #fff;
  }
}
</style>



// WEBPACK FOOTER //
// ../../../../resources/assets/js/utvStore/components/YearLuck/y2021/yearluck2021Top.vue